import React from "react";
import nutritionImage from "../assets/images/philosophy-nutrition.jpg";
import ContactUs from "./organisms/ContactUs";
import HeadingText from "./atoms/HeadingText";
import ContentText from "./atoms/ContentText";
import useTranslate from "../hooks/useTranslate";

function Philosopy() {
  const heading = useTranslate("workwithMnPage.philosophy.section.heading");
  const subheading = useTranslate(
    "workwithMnPage.philosophy.section.subheading"
  );
  const contentText = useTranslate(
    "workwithMnPage.philosophy.section.contentText"
  );

  return (
    <>
      <section className=" bg-white py-12">
        <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row">
          <div className="basis-1/2">
            <HeadingText variant="h2"> {heading}</HeadingText>
            <HeadingText variant="h3">{subheading}</HeadingText>
            <ContentText>{contentText}</ContentText>
          </div>
          <div className="basis-1/2 ">
            <img
              src={nutritionImage}
              alt="Nutrition"
              className="md:max-w-[90%] max-w-[100%] ml-auto"
            />
          </div>
        </div>
      </section>
      <ContactUs />
    </>
  );
}

export default Philosopy;
